import { render, staticRenderFns } from "./DichVuGiaiTriForm.vue?vue&type=template&id=73a36e73&scoped=true"
import script from "./DichVuGiaiTriForm.vue?vue&type=script&lang=js"
export * from "./DichVuGiaiTriForm.vue?vue&type=script&lang=js"
import style0 from "./DichVuGiaiTriForm.vue?vue&type=style&index=0&id=73a36e73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a36e73",
  null
  
)

export default component.exports